import { LayoutsModule } from 'src/app/layouts/layouts.module';
import { NgModule } from '@angular/core';
import { ParticipantCreateComponent } from './create/participant-create.component';
import { ParticipantEditComponent } from './edit/participant-edit.component';
import { ParticipantInfoComponent } from './dashboard/participant-info.component';
import { ParticipantListComponent } from './list/participant-list.component';
import { participantPages } from './participants.routes';
import { ParticipantResolver } from '@app/services/participants/participant.resolver';
import { ParticipantWorkflowComponent } from './workflow/participant-workflow.component';
import { QuestionnaireOverviewComponent } from '@workflow/components/questionnaire/overview/questionnaire-overview.component';
import { Routes, RouterModule } from '@angular/router';
import { WorkflowDetailsComponent } from '@workflow/components/details/workflow-details.component';
import { WorkflowUrlNavigatorComponent } from '@workflow/components/navigator/workflow-url-navigator.component';
import { DevNullComponent } from '@app/workflow/components/navigator/dev-null.component';
import { AuthGuard } from '@app/components/cleanui/system/Guard/auth.guard';
import { ParticipantWorkflowListComponent } from '@app/pages/participant/list/participant-workflow-list.component';
import { EWorkflowPathKey } from '@app/pages/participant/workflow/workflow-path-key.enum';
import { WorkflowGuard } from '@app/components/cleanui/system/Guard/workflow.guard';
import { WorkflowRandomizationComponent } from '@workflow/components/randomization/workflow-randomization.component';

// Teilnehmerseiten - Participant Pages

export const participantsRoutes: Routes = [
	{
		path: participantPages.dashboard.url,
		component: ParticipantListComponent,
		canActivate: [AuthGuard],
		data: {
			title: 'Teilnehmer - Übersicht',
			permissions: ['participants:read'],
		}
	},
	{
		path: participantPages.workflowDashboard.url,
		component: ParticipantWorkflowListComponent,
		canActivate: [AuthGuard],
		data: {
			title: 'Teilnehmer - Übersicht',
			all_permissions: ['participants:read', 'workflow:item:read'],
		}
	},
	{
		path: participantPages.create.url,
		component: ParticipantCreateComponent,
		canActivate: [AuthGuard],
		data: {
			title: 'Teilnehmer - Erstellen',
			permissions: ['participants:create'],
		},
	},
	{
		path: participantPages.edit.url,
		component: ParticipantEditComponent,
		data: {
			title: 'Teilnehmer - Editieren',
			permissions: ['participants:write', 'participants:delete'],
		},
		canActivate: [AuthGuard],
		resolve: { data: ParticipantResolver }
	},
	{
		path: participantPages.stammDaten.url,
		component: ParticipantInfoComponent,
		data: {
			title: 'Teilnehmer - Datenblatt',
			permissions: ['participants:read'],
		},
		canActivate: [AuthGuard],
		resolve: { data: ParticipantResolver }
	},
	{
		path: participantPages.workflow.url,
		component: ParticipantWorkflowComponent,
		data: {
			title: 'Teilnehmer - Workflow',
			permissions: ['workflow:item:read'],
		},
		canActivate: [AuthGuard],
		resolve: { data: ParticipantResolver }
	},
	{
		path: participantPages.workflowRandomizationItem.url,
		component: WorkflowRandomizationComponent,
		data: {
			title: 'Teilnehmer - Randomisierung',
			permissions: ['workflow:item:read'],
		},
		canActivate: [AuthGuard],
		resolve: { data: ParticipantResolver },
	},
	{
		path: participantPages.workflowProcess.url,
		component: WorkflowUrlNavigatorComponent,
		data: {
			title: 'Teilnehmer - Workflowprozess',
			permissions: ['workflow:item:read'],
		},
		canActivate: [AuthGuard],
		resolve: { data: ParticipantResolver },
		children: [
			{ path: '**', component: DevNullComponent },
		],
	},
	{
		path: participantPages.workflowOverview.url,
		component: QuestionnaireOverviewComponent,
		data: {
			title: 'Teilnehmer - Workflow - Übersicht',
			permissions: ['workflow:item:read'],
			key: EWorkflowPathKey.OVERVIEW,
		},
		canActivate: [AuthGuard, WorkflowGuard],
		resolve: { data: ParticipantResolver }
	},
	{
		path: participantPages.workflowDetails.url,
		component: WorkflowDetailsComponent,
		data: {
			title: 'Teilnehmer - Workflow - Details',
			permissions: ['workflow:item:read'],
			key: EWorkflowPathKey.DETAIL,
		},
		canActivate: [AuthGuard, WorkflowGuard],
		resolve: { data: ParticipantResolver }
	},
];

@NgModule({
	imports: [LayoutsModule, RouterModule.forChild(participantsRoutes)],
	providers: [],
	exports: [RouterModule]
})
export class ParticipantsRouterModule {}
